export const GET_ACCOUNT = "GET_ACCOUNT";
export const GET_NFT = "GET_NFT";
export const GET_SINGLE_NFT = "GET_SINGLE_NFT";